module.exports = __webpack_public_path__ + "images/start-harmonie-muenchen-1-624ab06fdc08fb06dc3e27b3a4d2238f.jpg";